import React, { useContext } from 'react';
import { useDocumentOnce } from 'react-firebase-hooks/firestore';
import { useParams } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/firestore';
import HorizontalCenter from '@components/common/alignment/HorizontalCenter';
import ErrorPage from '@components/common/Error';
import LoadingPage from '@components/common/Loading';
import { AnnouncementData } from '@ypp-portal/models/announcement/announcementData';
import { PlaceholderProcessor } from '@util/placeholder/PlaceholderProcessor';
import { UsernameTransformation } from '@util/placeholder/transformations/Username';
import { UserData } from '@ypp-portal/models/user/userData';
import { GenericAuthContext } from '@src/authContexts';
import { Viewer } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import { AnnouncementDataConverter } from '@data/announcements/AnnouncementDataConverter';

const converter = new AnnouncementDataConverter();

const AnnouncementPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [doc, loading, error] = useDocumentOnce<AnnouncementData>(
    firebase.firestore().collection('announcements').doc(id).withConverter(converter)
  );
  const data = doc?.data();

  const { userDoc } = useContext(GenericAuthContext);
  const processor = new PlaceholderProcessor([
    new UsernameTransformation(userDoc.data() as UserData),
  ]);

  if (loading) {
    return <LoadingPage></LoadingPage>;
  }

  if (error || !data) {
    return <ErrorPage></ErrorPage>;
  }

  return (
    <>
      <HorizontalCenter>
        <div className='w-2/5 mt-32 mb-8'>
          <img src={process.env.PUBLIC_URL + '/images/announcement/banner.jpg'}></img>
        </div>
      </HorizontalCenter>
      <HorizontalCenter>
        <div className='bg-cultured w-2/5 p-8 mb-10 min-h-96'>
          <div className='flex justify-end w-full'>
            <div className='text-coffee font-raleway text-xl -mt-2 mb-1'>
              {data.created.toDate().toLocaleDateString()}
            </div>
          </div>
          <article>
            <Viewer initialValue={processor.run(data.content)}></Viewer>
          </article>
        </div>
      </HorizontalCenter>
    </>
  );
};

export default AnnouncementPage;
